<div class="mt-4">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-header card-header-info card-header-icon">
            <div class="card-icon">
              <i class="material-icons">attach_money</i>
            </div>
            <h4 class="card-title">Currency</h4>
          </div>

          <div class="card-body">
            <div class="toolbar">
              <!--        Here you can write extra buttons/actions for the toolbar              -->
              <div class="row">
                <div class="col-12" style="text-align: right">
                  <button class="btn btn-success btn-md" 
                    (click)="create()"
                  >
                    <i class="fa fa-plus" aria-hidden="true"></i> New Currency
                  </button>
                </div>
              </div>
            </div>
              <loading *ngIf="loadingCurrencies"></loading>
            
            <div *ngIf="!loadingCurrencies">
             
              <div class="material-datatables">
                <table
                  id="productTable"
                  class="table table-striped table-no-bordered table-hover"
                  cellspacing="0"
                  width="100%"
                  style="width: 100%"
                >
                  <thead>
                    <tr >
                      <th><b> ID </b></th>
                      <th><b> Currency </b></th>
                      <th style="text-align: right"><b>Actions</b></th>
                    </tr>
                  </thead>

                  <tbody>
                    <tr *ngFor="let item of currencies">
                      <td>{{item.id}}</td>
                      <td>{{item.name}}</td>
                      <td style="text-align: right">
                        <button
                          class="btn btn-sm btn-link btn-info btn-just-icon"
                          title="Show Ditail"
                           (click)="detail(item)"
                        >
                          <i class="fa fa-eye" aria-hidden="true"></i>
                        </button>

                        <button
                          class="btn btn-sm btn-link btn-danger btn-just-icon"
                          title="Delete"
                          (click)="deleteCurren(item)"
                        >
                          <i class="fa fa-trash-o" aria-hidden="true"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="ModalCurrency" tabindex="-1" role="dialog">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2>
          <b></b>
        </h2>
      </div>

      <div class="modal-body">
        <form #f="ngForm">
          <div class="row">
            <div class="col-12">
              <mat-form-field>
                <mat-label>Name</mat-label>
                <input
                  matInput
                  name="conditionName"
                   [(ngModel)]="condition.name"
                  required
                />
              </mat-form-field>
            </div>
          </div>
        </form>
      </div>

      <div class="modal-footer">
        <button
          type="button"
          class="btn btn-default btn-md"
          data-dismiss="modal"
        >
          Close
        </button>

        &nbsp;&nbsp;

        <button
          type="button"
          class="btn btn-primary btn-md"
          (click)="editCurrencies(condition)"
        >
         
          &nbsp; Save
        </button>
      </div>
    </div>
  </div>
</div>
